import { Alert, Checkbox, FormControlLabel, Stack, Typography } from "@mui/material";

interface Props {
  text: string;
  confirmLabel: string;
  confirmed: boolean;
  onConfirmedChange: (confirmed: boolean) => void;
}

const EmailOwnershipNotice = ({ text, confirmLabel, confirmed, onConfirmedChange }: Props) => (
  <Alert severity="warning">
    <Stack spacing={1}>
      <Typography variant="inherit">{text}</Typography>
      <FormControlLabel
        label={confirmLabel}
        control={<Checkbox checked={confirmed} onChange={(_, checked) => onConfirmedChange(checked)} />}
      />
    </Stack>
  </Alert>
);

export default EmailOwnershipNotice;
